// extracted by mini-css-extract-plugin
var _1 = "Zj5Jtxg9fKFlB9YC_pVO";
export { _1 as "subNavSnippet" }
